export function sellerAdvisoryVacantLandKWSW() {
return [   // Release 2026-01-09 10:03:07
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 152.273,
   left: 183.927,
   width: 372.753,
   height: 14.978
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 180.255,
   left: 183.927,
   width: 372.753,
   height: 14.977
}
,
{
   page: 0,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 206.6,
   left: 183.927,
   width: 372.753,
   height: 14.978
}
,
{
   page: 4,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 420.908,
   left: 70.7273,
   width: 171.1197,
   height: 14.869
}
,
{
   page: 4,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 420.908,
   left: 244.96,
   width: 62.957,
   height: 14.869
}
] }
